import type { LinkDataObject } from '../../../../main/types/links';
import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_QR_CODE_LINK_CUSTOM_LINK_DATA = 'UPDATE_QR_CODE_LINK_CUSTOM_LINK_DATA' as const;

export const updateQrCodeLinkCustomLinkData = (customLinkData: LinkDataObject[]) => ({
  data: { customLinkData },
  type: UPDATE_QR_CODE_LINK_CUSTOM_LINK_DATA,
});

export type UpdateQrCodeLinkCustomLinkDataResponseAction = DataAction<
  typeof UPDATE_QR_CODE_LINK_CUSTOM_LINK_DATA,
  { customLinkData: LinkDataObject[] }
>;
